import { connect } from 'react-redux'
import type { Dispatch } from 'redux'
import type { RootState } from 'shared/store/reducers'
import { sendSatisfactionForm } from 'shared/store/satisfaction'
import { searchAll } from 'shared/store/store-locator'
import type { SatisfactionForm } from 'shared/types'
import { getUrlParams } from 'shared/utils/ecommerce/utils'
import { SatisfactionComponent } from './SatisfactionComponent'

const mapStateToProps = (state: RootState) => {
    const { shortRestaurants } = state.storeLocatorPageState
    const { restaurant } = getUrlParams(state.router.location.search)
    const restaurantFromUrl =
        restaurant &&
        shortRestaurants &&
        shortRestaurants.find(r => r.pageUrl === restaurant)
    return {
        ...state.satisfactionPageState,
        restaurants: shortRestaurants,
        restaurantFromUrl
    }
}

const mapDispatchToProps = (d: Dispatch<any>) => ({
    sendForm: (form: SatisfactionForm) => d(sendSatisfactionForm(form)),
    searchAll: () => d(searchAll())
})

export const Satisfaction = connect(
    mapStateToProps,
    mapDispatchToProps
)(SatisfactionComponent)
